export function formatPrice(value, separator = ' ') {
  const preparedValue = String(value).replace(/\s/g, '').replace(/,/g, '.');
  return preparedValue.replace(/(\d)(?=(?:\d{3})+\b)/gm, `$1${separator}`);
}

// eslint-disable-next-line complexity
export function tipsFormatter(event, oldValue = '') {
  if (!event.target.value) {
    return true;
  }

  const parts = event.target.value.split(',');
  const lastPart = parts[parts.length - 1];

  // контроль ввода запятых и цифр
  if (/[^,0-9]+/g.test(event.target.value)) {
    event.target.value = event.target.value.replaceAll(/[^,0-9]+/g, '');
    return false;
  }

  // не более 4 значений
  if (parts.length > 4) {
    event.target.value = parts.slice(0, 4).join(',');
    return false;
  }

  // минимальное значение 1%
  const filteredParts = parts.map(part => Number(part)).filter(part => part > 0);

  if (filteredParts.length !== parts.length && lastPart !== '') {
    event.target.value = filteredParts.slice(0, 4).join(',');
    return false;
  }

  // максимальное 999%
  const maxPercentage = 999;
  const hasMaxValueOverflow = !!filteredParts.find(part => part > maxPercentage);

  //ограничение на пустые значения кроме последнего
  const emptyParts = parts.filter(part => !part);
  const hasEmptyVariants = !!((emptyParts.length > 1) || (emptyParts.length && lastPart !== ''));
  if (hasMaxValueOverflow || hasEmptyVariants) {
    event.target.value = oldValue;
    return false;
  }

  return true;
}
